module.exports = __webpack_public_path__ + "static/media/teacher_small.56e7da24.jpg";